import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-xs text-foreground-300"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-950 font-medium whitespace-nowrap">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}